import MenuIconWrapper from 'src/components/MenuIconWrapper';

const DashboardIcon = () => {
  return (
    <MenuIconWrapper>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 13V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H13"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.32996 14.4917L9.70996 11.4017C10.05 10.9617 10.68 10.8817 11.12 11.2217L12.95 12.6617C13.39 13.0017 14.02 12.9217 14.36 12.4917L16.67 9.51172"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.48 15.8214L19.76 16.3914C19.9 16.6714 20.25 16.9314 20.56 16.9914L20.94 17.0514C22.08 17.2414 22.35 18.0814 21.53 18.9114L21.18 19.2614C20.95 19.5014 20.82 19.9614 20.89 20.2814L20.94 20.4914C21.25 21.8714 20.52 22.4014 19.32 21.6814L19.06 21.5314C18.75 21.3514 18.25 21.3514 17.94 21.5314L17.68 21.6814C16.47 22.4114 15.74 21.8714 16.06 20.4914L16.1099 20.2814C16.1799 19.9614 16.05 19.5014 15.82 19.2614L15.47 18.9114C14.65 18.0814 14.92 17.2414 16.06 17.0514L16.44 16.9914C16.74 16.9414 17.1 16.6714 17.24 16.3914L17.52 15.8214C18.06 14.7314 18.94 14.7314 19.48 15.8214Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </MenuIconWrapper>
  );
};

export default DashboardIcon;
